export { JSONAPICache as default } from '@warp-drive/json-api';
